export enum FieldsEnum {
  OBJECTIVE = 1,
  INCIDENT_FOLDER = 2,
  INCIDENT = 3,
  INJECTION = 4,
  ACTION = 5,
  OUTCOME = 6,
  OBSERVATION_TASK = 7,
  CONFIGURATION_CHANGE_REQUEST = 8,
  TROUBLE_TICKET = 9,
  STATE = 10,
  TRANSACTION = 11,
  LILL = 12,
  TECHNICAL_SUPPORT_REQUEST = 13,
  ACTORBOOK = 14,
  SETTING = 15,
  ROAD_TO_CURRENT_SETTINGS = 16,
  TASK = 17,
  WORK_PACKAGE = 18,
  PROJECT_INPUT = 19,
  KANBAN = 20,
  DELIVERABLE = 21,
  TEST = 22,
  BATTLE_RHYTHM = 23,
  LINE_OF_EFFORT = 24,
  PLAN_ORDER_REPORT_PROCESS = 25,
  DECISIVE_CONDITIONS = 26,
  OD_TASK = 27,
  EFFECT = 28,
  PHASE = 29,
  TURN_CHART = 30,
  PROJECTS = 31,
  COA = 32,
  SYNC_MATRIX = 33,
  COA_ANALYSIS = 34,
  RISK = 35,
}
